import { render, staticRenderFns } from "./ex-card.vue?vue&type=template&id=472f4204&scoped=true&"
import script from "./ex-card.vue?vue&type=script&lang=js&"
export * from "./ex-card.vue?vue&type=script&lang=js&"
import style0 from "./ex-card.vue?vue&type=style&index=0&id=472f4204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f4204",
  null
  
)

export default component.exports